import { RoleType } from '@tribeplatform/gql-client/types';
import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthMemberKey } from '../../utils/keys';
import { useCachedAuthMember } from '../cache';
export const useAuthMember = (options) => {
    var _a, _b, _c, _d, _e;
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const authMemberKey = getAuthMemberKey({ fields });
    const query = useQuery(authMemberKey, () => client.auth.authMember(fields), {
        placeholderData: useCachedAuthMember(),
        ...useQueryOptions,
    });
    const member = query === null || query === void 0 ? void 0 : query.data;
    const isAdmin = ((_a = member === null || member === void 0 ? void 0 : member.role) === null || _a === void 0 ? void 0 : _a.type) === RoleType.admin;
    const isModerator = ((_b = member === null || member === void 0 ? void 0 : member.role) === null || _b === void 0 ? void 0 : _b.type) === RoleType.moderator ||
        ((_c = member === null || member === void 0 ? void 0 : member.role) === null || _c === void 0 ? void 0 : _c.type) === RoleType.admin;
    const isGuest = !member || !((_d = member === null || member === void 0 ? void 0 : member.role) === null || _d === void 0 ? void 0 : _d.type) || ((_e = member === null || member === void 0 ? void 0 : member.role) === null || _e === void 0 ? void 0 : _e.type) === RoleType.guest;
    return {
        isAdmin,
        isGuest,
        isModerator,
        ...query,
    };
};
//# sourceMappingURL=useAuthMember.js.map